(function () {
  var config = window.PinkgulSearchConfig || {};
  var strings = config.strings || {};
  var predictiveUrl = config.predictiveUrl || '/search/suggest.json';
  var searchUrl = config.searchUrl || '/search';
  var moneyFormat = config.moneyFormat || '${{amount}}';
  var debounceDelay = Number(config.debounceDelay || 275);
  var minimumCharacters = Number(config.minimumCharacters || 2);

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(value) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Math.round(Number(value || 0) * 100), moneyFormat);
    }

    return Number(value || 0).toFixed(2);
  }

  function formatTemplate(template, replacements) {
    return String(template || '')
      .replace(/\{\{\s*count\s*\}\}/g, replacements.count)
      .replace(/\{\{\s*terms\s*\}\}/g, replacements.terms);
  }

  function getProductResults(payload) {
    var products = payload && payload.resources && payload.resources.results && payload.resources.results.products;
    return Array.isArray(products) ? products : [];
  }

  function getResultImage(product) {
    if (product.featured_image && typeof product.featured_image === 'object') {
      return {
        url: product.featured_image.url || product.featured_image.src || '',
        alt: product.featured_image.alt || product.title || ''
      };
    }

    return {
      url: product.image || '',
      alt: product.title || ''
    };
  }

  function getResultState(product) {
    var price = Number(product.price || 0);
    var compareAt = Number(product.compare_at_price_max || 0);

    if (!product.available) {
      return strings.soldOut || 'Sold out';
    }

    if (compareAt > price) {
      return strings.sale || 'Sale';
    }

    return '';
  }

  function getSizedImageUrl(url, width) {
    if (!url) return '';
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'width=' + encodeURIComponent(String(width));
  }

  function buildResultMarkup(product) {
    var image = getResultImage(product);
    var state = getResultState(product);
    var price = formatMoney(product.price);
    var compareAt = Number(product.compare_at_price_max || 0) > Number(product.price || 0)
      ? formatMoney(product.compare_at_price_max)
      : '';
    var imageSrc = getSizedImageUrl(image.url, 160);
    var imageSrcSet = imageSrc
      ? imageSrc + ' 1x, ' + getSizedImageUrl(image.url, 320) + ' 2x'
      : '';

    return [
      '<a class="site-header__search-result" role="listitem" href="' + escapeHtml(product.url) + '">',
        '<span class="site-header__search-result-media">',
          imageSrc ? '<img class="site-header__search-result-image" src="' + escapeHtml(imageSrc) + '" srcset="' + escapeHtml(imageSrcSet) + '" sizes="56px" alt="' + escapeHtml(image.alt) + '" loading="lazy" decoding="async">' : '<span class="site-header__search-result-placeholder" aria-hidden="true"></span>',
        '</span>',
        '<span class="site-header__search-result-content">',
          '<span class="site-header__search-result-title">' + escapeHtml(product.title || '') + '</span>',
          '<span class="site-header__search-result-meta">',
            '<span class="site-header__search-result-price">' + escapeHtml(price) + '</span>',
            compareAt ? '<s class="site-header__search-result-compare-at">' + escapeHtml(compareAt) + '</s>' : '',
            state ? '<span class="site-header__search-result-state">' + escapeHtml(state) + '</span>' : '',
          '</span>',
        '</span>',
      '</a>'
    ].join('');
  }

  function setHidden(node, hidden) {
    if (!node) return;
    node.hidden = hidden;
    node.classList.toggle('visually-hidden', hidden);
  }

  function bindPredictiveWidget(widget) {
    if (!widget || widget.dataset.searchBound === 'true') return;
    widget.dataset.searchBound = 'true';

    var trigger = widget.querySelector('[data-search-trigger]');
    var panel = widget.querySelector('[data-search-panel]');
    var form = widget.querySelector('[data-search-form]');
    var input = widget.querySelector('[data-search-input]');
    var results = widget.querySelector('[data-search-results]');
    var status = widget.querySelector('[data-search-status]');
    var viewAll = widget.querySelector('[data-search-view-all]');
    var retryButton = widget.querySelector('[data-search-retry]');
    var requestToken = 0;
    var activeController = null;
    var debounceTimer = null;
    var isOpen = false;

    function closeWidget(restoreFocus) {
      isOpen = false;
      widget.classList.remove('is-open');
      setHidden(panel, true);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      if (restoreFocus && trigger) {
        trigger.focus();
      }
    }

    function openWidget() {
      isOpen = true;
      widget.classList.add('is-open');
      setHidden(panel, false);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
      window.requestAnimationFrame(function () {
        if (input) input.focus();
      });
    }

    function clearResults() {
      if (results) results.innerHTML = '';
      if (viewAll) setHidden(viewAll, true);
      if (retryButton) setHidden(retryButton, true);
    }

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('site-header__search-status--error', Boolean(isError));
    }

    function setLoadingState(loading) {
      widget.classList.toggle('is-loading', loading);
      if (input) input.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function renderResults(products, query) {
      if (!results) return;

      if (!products.length) {
        results.innerHTML = '';
        setStatus(strings.noResultsHtml ? formatTemplate(strings.noResultsHtml, { count: 0, terms: query }) : (strings.noResults || 'No results found'), false);
        if (viewAll) {
          viewAll.href = searchUrl + '?type=product&q=' + encodeURIComponent(query);
          setHidden(viewAll, false);
        }
        if (retryButton) setHidden(retryButton, true);
        return;
      }

      results.innerHTML = products.map(buildResultMarkup).join('');
      setStatus(strings.resultsCountHtml ? formatTemplate(strings.resultsCountHtml, { count: products.length, terms: query }) : '', false);
      if (viewAll) {
        viewAll.href = searchUrl + '?type=product&q=' + encodeURIComponent(query);
        setHidden(viewAll, false);
      }
      if (retryButton) setHidden(retryButton, true);
    }

    async function fetchResults(query) {
      var currentToken = ++requestToken;

      if (activeController) {
        activeController.abort();
      }

      activeController = new AbortController();

      setLoadingState(true);
      setStatus(strings.loading || 'Loading...', false);

      try {
        var url = new URL(predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', String(config.previewLimit || 6));
        url.searchParams.set('resources[limit_scope]', 'each');

        var response = await fetch(url.toString(), {
          credentials: 'same-origin',
          signal: activeController.signal,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error('Predictive search failed');
        }

        var payload = await response.json();

        if (currentToken !== requestToken) {
          return;
        }

        renderResults(getProductResults(payload), query);
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }

        clearResults();
        setStatus(strings.error || 'Could not load results. Please try again.', true);
        if (retryButton) setHidden(retryButton, false);
      } finally {
        if (currentToken === requestToken) {
          setLoadingState(false);
        }
      }
    }

    function queueSearch() {
      if (!input) return;

      clearTimeout(debounceTimer);

      var query = input.value.trim();

      if (query.length < minimumCharacters) {
        if (activeController) activeController.abort();
        clearResults();
        setLoadingState(false);
        setStatus(strings.minimumCharacters || 'Type at least 2 characters to search.', false);
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(query);
      }, debounceDelay);
    }

    function toggleWidget() {
      if (isOpen) {
        closeWidget(false);
      } else {
        openWidget();
        queueSearch();
      }
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        toggleWidget();
      });
    }

    if (input) {
      input.addEventListener('focus', function () {
        openWidget();
        if (input.value.trim().length >= minimumCharacters) {
          queueSearch();
        } else {
          clearResults();
          setStatus(strings.minimumCharacters || 'Type at least 2 characters to search.', false);
        }
      });

      input.addEventListener('input', function () {
        openWidget();
        queueSearch();
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeWidget(true);
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        closeWidget(false);
      });
    }

    if (retryButton) {
      retryButton.addEventListener('click', function () {
        if (input) {
          queueSearch();
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (!widget.contains(event.target)) {
        closeWidget(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        closeWidget(true);
      }
    });

    closeWidget(false);
  }

  function bindSearchResultsSection(section) {
    if (!section || section.dataset.searchResultsBound === 'true') return;
    section.dataset.searchResultsBound = 'true';

    var grid = section.querySelector('[data-search-results-grid]');
    var pagination = section.querySelector('[data-search-pagination]');

    if (!grid || !pagination) return;

    var statusNode = pagination.querySelector('[data-search-load-status]');

    function setStatus(message, isError) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      statusNode.classList.remove('visually-hidden');
      statusNode.classList.toggle('search-page__load-status--error', Boolean(isError));
    }

    function clearStatus() {
      if (!statusNode) return;
      statusNode.textContent = '';
      statusNode.classList.add('visually-hidden');
      statusNode.classList.remove('search-page__load-status--error');
    }

    function setLoadingState(link, isLoading) {
      var defaultLabel = link.dataset.labelDefault || strings.loadMore || 'Load more';
      var loadingLabel = link.dataset.labelLoading || strings.loading || 'Loading...';

      link.dataset.loading = isLoading ? 'true' : 'false';
      link.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      link.textContent = isLoading ? loadingLabel : defaultLabel;
    }

    function buildSectionRequestUrl(nextPageUrl) {
      var url = new URL(nextPageUrl, window.location.origin);
      url.searchParams.set('section_id', section.dataset.searchResultsSectionId);
      return url.toString();
    }

    function bindLoadMore(link) {
      if (!link) return;

      link.addEventListener('click', async function (event) {
        event.preventDefault();

        if (link.dataset.loading === 'true') return;

        clearStatus();
        setLoadingState(link, true);
        setStatus(strings.loading || 'Loading...', false);

        try {
          var response = await fetch(buildSectionRequestUrl(link.href), {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) {
            throw new Error('Request failed with status ' + response.status);
          }

          var html = await response.text();
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = parsed.querySelector('[data-search-results-grid]');

          if (!nextGrid) {
            throw new Error('Search grid not found in response');
          }

          Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
            grid.appendChild(child);
          });

          var nextPagination = parsed.querySelector('[data-search-pagination]');
          var nextLink = nextPagination ? nextPagination.querySelector('[data-search-load-more]') : null;

          if (nextLink) {
            pagination.innerHTML = nextPagination.innerHTML;
            bindLoadMore(pagination.querySelector('[data-search-load-more]'));
          } else {
            pagination.remove();
          }

          setStatus(strings.loadMoreLoaded || 'More products loaded', false);
        } catch (error) {
          setLoadingState(link, false);
          setStatus(strings.loadMoreError || 'Could not load more products. Please try again.', true);
        }
      });
    }

    bindLoadMore(pagination.querySelector('[data-search-load-more]'));
  }

  function initialize() {
    document.querySelectorAll('[data-search-widget]').forEach(bindPredictiveWidget);
    document.querySelectorAll('[data-search-results-section-id]').forEach(bindSearchResultsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();